// Un retweet garde la convention historique « RT @compte: texte » (collecte X,
// api47_v3.py). L'index porte aussi `is_retweet`, mais pas pour les anciennes
// données : le préfixe fait donc foi quand le drapeau manque.
// Le texte arrive avec des <mark> autour des mots recherchés, y compris dans le
// préfixe (« RT <mark>@compte</mark>: ») : on les tolère entre chaque jeton.
const TAGS = String.raw`(?:<\/?mark[^>]*>)*`;
const RETWEET_PREFIX = new RegExp(
  String.raw`^\s*${TAGS}RT${TAGS}\s+${TAGS}@((?:\w|<\/?mark[^>]*>){1,120}):\s*`,
  "i"
);

/**
 * Lien vers le post d'origine : `original_ref` (identifiant du tweet d'origine,
 * écrit par la collecte) avec le compte du préfixe quand on l'a, sinon le lien
 * générique qui redirige tout seul. Sans identifiant, pas de lien.
 *
 * @param {{ text?: string|null, is_retweet?: boolean|null, original_ref?: string|null }} post
 * @returns {{ isRetweet: boolean, originalHandle: string|null, originalUrl: string|null, text: string }}
 */
export function parseRetweet(post) {
  const text = post?.text ?? "";
  const match = text.match(RETWEET_PREFIX);
  const originalHandle = match ? stripMarks(match[1]) : null;
  const isRetweet = Boolean(match) || Boolean(post?.is_retweet);

  return {
    isRetweet,
    originalHandle,
    originalUrl: isRetweet ? getOriginalUrl(originalHandle, post) : null,
    text: match ? text.slice(match[0].length) : text,
  };
}

function stripMarks(value) {
  return value.replace(/<\/?mark[^>]*>/g, "");
}

function getOriginalUrl(handle, post) {
  const ref = String(post?.original_ref ?? "");
  if (!/^\d+$/.test(ref)) return null;
  return handle
    ? `https://x.com/${handle}/status/${ref}`
    : `https://x.com/i/web/status/${ref}`;
}
